"use client";

import { useMemo } from "react";
import useTranslations from "@/i18n/useTranslations";

export function useCarouselMessages() {
  const t = useTranslations("Carousel");

  return useMemo(
    () => ({
      previousSlide: t("previousSlide"),
      nextSlide: t("nextSlide"),
      goToSlide: (number: number) => t("goToSlide", { number }),
      goToSlideGroup: (number: number) => t("goToSlideGroup", { number }),
      homepageHeroCarousel: t("homepageHeroCarousel"),
      moreInformation: t("moreInformation"),
      socialProofCarousel: t("socialProofCarousel"),
      slideLabel: (number: number) => t("slideLabel", { number }),
      recentlyViewedProducts: t("recentlyViewedProducts"),
      previousArticles: t("previousArticles"),
      nextArticles: t("nextArticles"),
      goToPreviousSlide: t("goToPreviousSlide"),
      goToNextSlide: t("goToNextSlide"),
      scrollLeft: t("scrollLeft"),
      scrollRight: t("scrollRight"),
    }),
    [t],
  );
}
